import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mb-plus-sm",
  "use": "mb-plus-sm-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"mb-plus-sm\">\r\n    \r\n    <g>\r\n    <path d=\"M22.892 14.622h-6.033v-6.033h-1.776v6.033h-6.032v1.775h6.033v6.033h1.775v-6.033h6.033z\" fill=\"rgba(182,182,182,1)\" />\r\n    </g>\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol